var _circle, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLifeGoalBgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 308,
    viewBox: "0 0 345 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 57.5,
    cy: 123.5,
    r: 287.5,
    fill: "#152C57"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 99,
    cy: 69.5,
    rx: 163,
    ry: 163.5,
    fill: "#152C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeGoalBgDark);
export default __webpack_public_path__ + "static/media/life-goal-bg-dark.0d1da7726683db7d6059e4c507601a09.svg";
export { ForwardRef as ReactComponent };